import { setLanguage } from "../../util/i18n.functions";
import { Education } from "../../Models/firebaseHelper.types";
import { keys } from "../../strings";

/**
 * Sets up the language for the first time. Based on the first available course language.
 * 
 * @param lang - The language to set, either "sv" for Swedish or "en" for English.
 */
export function setupLanguage(lang: string, set: Function = setLanguage): void {
    if (lang === "sv" || lang === "en") {
      localStorage.setItem(keys.localStorage.language, lang);
      localStorage.setItem(keys.localStorage.i18nextLng, lang);
      set(lang);
    }
}

/**
 * Checks the available courses and sets the language based on the first course's language.
 * If no language is set in localStorage, it will set it based on the first course found.
 * 
 * @param educations - An array of Education objects to check for available courses.
 * @param setup - A function to set the language, defaults to `setupLanguage`.
 */
export async function checkLanguage(resolver: () => Promise<Education[]>, setup: Function = setupLanguage): Promise<void> {
  if (!localStorage.getItem(keys.localStorage.language)) {
    const availableCourses = await resolver();
    const firstCourse = availableCourses.length > 0 ? availableCourses[0] : null;

    if (firstCourse?.Language) {
      switch (firstCourse.Language) {
        case "swedish":
          setup("sv");
          break;
        case "english":
          setup("en");
          break;
        default:
          console.warn(
            `Unknown language for course ${firstCourse.ID}: ${firstCourse.Language}`
          );
          break;
      }
    }
  }
}
